import { Tag } from "@zendeskgarden/react-tags";
import { statusColors, statusTitles } from "./statusColors";
import { StatusTagProps } from "./statutsTagProps";

export default function StatusTag(props: StatusTagProps) {
  const backgroundColor = statusColors[props.status] || "#666666"; // Default color for custom statuses
  const title = statusTitles[props.status] || props.status; // Use status name for custom statuses

  return (
    <Tag
      style={{
        backgroundColor,
        color: "#fff",
      }}
    >
      {title}
    </Tag>
  );
}
